<small class="d-block bg-primary">
  <div class="d-flex justify-content-between">
    <div class="dropdown">
      <a [routerLink]="[]" data-bs-toggle="dropdown" aria-expanded="false">
        <i class="bi bi-caret-right"></i>
      </a>
      <ul class="dropdown-menu">
        <li>
          <a class="dropdown-item">
            <div class="d-flex justify-content-between">
              <div><i class="bi bi-chevron-bar-down"></i> MIN</div>
              <div>{{ min | number : ".2-2" }}%</div>
            </div>
          </a>
        </li>
        <li>
          <a class="dropdown-item">
            <div class="d-flex justify-content-between">
              <div><i class="bi bi-chevron-bar-up"></i> MAX</div>
              <div>{{ max | number : ".2-2" }}%</div>
            </div>
          </a>
        </li>
        <li>
          <a class="dropdown-item">
            <div class="d-flex justify-content-between">
              <div><i class="bi bi-p-circle"></i> AVG</div>
              <div>{{ avg | number : ".2-2" }}%</div>
            </div>
          </a>
        </li>
      </ul>
    </div>
    <div class="opacity-50">{{ avg | number : "0.2-2" }}%</div>
  </div>
</small>
